import type { StepKey } from '@develop/ia-component-library'
import type { CrossPlatformRedirectRoutes } from '@/models/cross-platform'

export const useRedirect = () => {
  const onCheckoutForward = (step: StepKey, draftId: string) => {
    switch (step) {
      case 'cart':
        customNavigateTo({ name: 'warenkorb-einzelheiten-draftId', params: { draftId } })
        break
      case 'customer':
        customNavigateTo({ name: 'warenkorb-kundendaten-draftId', params: { draftId } })
        break
      case 'delivery':
        customNavigateTo({ name: 'warenkorb-lieferart-draftId', params: { draftId } })
        break
      case 'overview':
        customNavigateTo({ name: 'warenkorb-uberprufen-draftId', params: { draftId } })
        break
      case 'payment':
        customNavigateTo({ name: 'warenkorb-zahlungsart-draftId', params: { draftId } })
        break
      case 'thank-you':
        customNavigateTo({ name: 'warenkorb-danke-draftId', params: { draftId } })
        break
    }
  }

  const crossPlatformRedirect = (_id: CrossPlatformRedirectRoutes) => {
    // location.href has to be used because customNavigateTo causes history issues
    // switch (id) {
    //   case 'kundenkonto-userId-email-andern':
    //     location.href = `/kundenkonto/email-andern/${userStore.user?.id}`
    //     break
    //   case 'kundenkonto-userId-email-andern-anfrage':
    //     location.href = `/kundenkonto/email-andern/anfrage/${userStore.user?.id}`
    //     break
    //   case 'kundenkonto-userId-email-andern-erfolg':
    //     location.href = `/kundenkonto/email-andern/erfolg/${userStore.user?.id}`
    //     break
    //   case 'kundenkonto-userId-passwort-andern':
    //     location.href = `/kundenkonto/passwort-andern/${userStore.user?.id}`
    //     break
    // }
  }

  return {
    onCheckoutForward,
    crossPlatformRedirect,
  }
}
